import React, { Component } from 'react';
import { Grid, } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import useStyles from './styles';
import { graphql, QueryRenderer } from 'react-relay';
import WMRightSectionResult from './WMRightSectionResult';
import environment from '../../environment';

const wmRightSectionQuery = graphql`
    query WMRightSectionQuery(
        $event_token: String!
        $guest_token: String!
        $quarter_id: Int!
    ){
        ...WMRightSectionResult_getLonewolfPersonalData @arguments(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id)
    }
`;

class WMRightSection extends Component {
    constructor(props){
        super(props);
        this.state = {
            refetch: false,
        }

        this.refetchData = this.refetchData.bind(this);
    }

    refetchData(){
        this.setState(prevState => {
            return { refetch: !prevState.refetch };
        });
    }

    render(){
        const { classes, event_token, quarter_id, current_chapter, chapters, quarter_index, guest_token, event_id } = this.props;
        const variables = { event_token: event_token, guest_token: guest_token ? guest_token : ' ', quarter_id: quarter_id, refetch: this.state.refetch };

        return (
            <Grid item xs={6} className={classes.rightContainer}>
                <QueryRenderer
                    environment={environment}
                    query={wmRightSectionQuery}
                    variables={variables}
                    render={({ error, props }) => {
                        if(props){
                            return (
                                <WMRightSectionResult
                                    quarter_id={quarter_id}
                                    getLonewolfPersonalData={props}
                                    chapters={chapters}
                                    guest_token={guest_token}
                                    event_id={event_id}
                                    refetchData={this.refetchData}
                                />
                            )
                        }
                    }}
                />
                <Grid item xs={12}>
                    <div style={{float: 'right', marginTop: '1em'}}>
                        {
                            quarter_index - 1 >= 0 ?
                            <span className={classes.pageArrow} onClick={() => this.props.changeChapter(-1)}>←</span> :
                            <span className={classes.pageArrowDisabled}>←</span>
                        }
                        <span className={classes.chapterName}>{current_chapter ? current_chapter.quarter_name : ''}</span>
                        {
                            quarter_index + 1 < chapters.length ?
                            <span className={classes.pageArrow} onClick={() => this.props.changeChapter(1)}>→</span> :
                            <span className={classes.pageArrowDisabled}>→</span>
                        }
                    </div>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(useStyles)(WMRightSection);